import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { signIn } from '@ghq-abi/auth-client-lib/client';

import { withSSRUnauth } from '~/app/hocs';
import { CredentialProvidersEnum } from '~/app/types';

export default function Redirect() {
  const hasRedirectedToSignIn = useRef(false);
  const router = useRouter();

  const errorMessage = router.query.error;
  const callbackUrl = router.query.callbackUrl ?? '/';

  useEffect(() => {
    if (errorMessage) {
      // Keep the destination and query together. The previous two-argument
      // form treated the object as Next's `as` argument and can make
      // Turbopack attempt a hard navigation back to this same URL.
      router.replace({
        pathname: '/auth/error',
        query: { error: errorMessage },
      });
    } else if (
      typeof callbackUrl === 'string' &&
      !hasRedirectedToSignIn.current
    ) {
      hasRedirectedToSignIn.current = true;

      // A direct visit to this page uses `/` as the callback. Resolve relative
      // callbacks against the current origin as well as the absolute URLs sent
      // by SSR guards.
      const cbUrlObj = new URL(callbackUrl, window.location.origin);
      const callbackUrlWithLocale = `${cbUrlObj.origin}${cbUrlObj.pathname}`;

      signIn(CredentialProvidersEnum.AZURE_AD, {
        redirect: false,
        callbackUrl: callbackUrlWithLocale,
      });
    }
  }, [callbackUrl, errorMessage, router]);

  return null;
}

export const getServerSideProps = withSSRUnauth(async () => ({ props: {} }), {
  tolgeeNamespaces: ['default'],
});

Redirect.unauth = true;
